import { NgModule } from '@angular/core';
import { AdvertCreateComponent } from '@component/marketplace/advert-create/advert-create.component';
import { AdvertDetailComponent } from '@component/marketplace/advert-detail/advert-detail.component';
import { AdvertDisplayComponent } from '@component/marketplace/advert-display/advert-display.component';
import { AdvertRelatedItemsComponent } from '@component/marketplace/advert-related-items/advert-related-items.component';
import { AdvertComponent } from '@component/marketplace/advert.component';
import { MarketplaceCategoriesComponent } from '@component/marketplace/marketplace-categories/marketplace-categories.component';
import { PaginationComponentModule } from '@component/pagination/pagination.component';
import { PrivateMessageComponentModule } from '@component/private-message/private-message.component';
import { AdvertGridItemModule } from '@component/shared/advert-grid-item/advert-grid-item.component';
import { MoneyInsertThousandSignsModule } from '@pipe/money-insert-thousand-signs';
import { EntityModule } from './entity.module';
import { SharedModule } from './shared.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { GridSortFilterComponent } from '@component/sort/sort.component';
import { MatUtilModule } from 'mat-util';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    AdvertComponent,
    AdvertRelatedItemsComponent,
    AdvertCreateComponent,
    AdvertDetailComponent,
    AdvertDisplayComponent,
    MarketplaceCategoriesComponent,
    GridSortFilterComponent,
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: '',
        data: {
          title: 'Marktplatz',
        },
        component: AdvertComponent,
      },
      {
        path: 'create',
        data: {
          title: 'Anzeige erstellen',
        },
        component: AdvertCreateComponent,
      },
      {
        path: 'edit/:id',
        data: {
          title: 'Anzeige bearbeiten',
        },
        component: AdvertCreateComponent,
      },

      /* The :name is pretty irrelevant when using stateservice.goto it's only necessary so that the slug later is written when the state is loaded for seo */
      {
        path: 'detail/:id/:name',
        component: AdvertDetailComponent,
      },
    ]),
    AdvertGridItemModule,
    PaginationComponentModule,
    EntityModule,
    MoneyInsertThousandSignsModule,
    PrivateMessageComponentModule,
    MatUtilModule,

    MatExpansionModule,
    MatSelectModule,
  ],
  exports: [
    AdvertComponent,
    AdvertRelatedItemsComponent,
    AdvertCreateComponent,
    AdvertDetailComponent,
    AdvertDisplayComponent,
    MarketplaceCategoriesComponent,
    GridSortFilterComponent,

    SharedModule,
    AdvertGridItemModule,
    PaginationComponentModule,
    EntityModule,
    MoneyInsertThousandSignsModule,
    PrivateMessageComponentModule,
    MatUtilModule,

    MatExpansionModule,
    MatSelectModule,
  ],
})
export class AdvertModule {}
